import { AzureUser } from "@lcms/identity-microsoft";
import { useAuthentication } from "@lcms/react-identity";
import { useMemo } from "react";

export function useUser() {
    const authentication = useAuthentication<AzureUser>();

    const user = useMemo(() => authentication?.type === 'vendor' ? authentication.user : null, [authentication?.type, authentication?.user]);
    return user;
}